module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "fm1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "NOTE-CT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A NOTE ON MONEY AND DATES")])]), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "BT1-fo"
  }, [_vm._v("English monetary values are recorded as being in pounds ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("l")]), _vm._v(") shillings ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("s")]), _vm._v(") and pence ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("d")]), _vm._v("), with twenty shillings in the pound and twelve pence in the shilling. The mark was a unit of account, with one mark being worth thirteen shillings and four pence, therefore 2/3rds of a pound. There are many pitfalls to estimating the value of currency across the centuries, however a useful guide is the National Archives’ Currency Converter (see "), _c('a', {
    attrs: {
      "href": "http://www.nationalarchives.gov.uk/currency",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nationalarchives.gov.uk/currency")]), _vm._v(") that suggests one pound in 1480 would have been worth an equivalent of £504.59 at 2005 prices, with one shilling worth an equivalent of £25.23 and one penny equalling £2.10. The standard unit of French money was the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("livre tournois")]), _vm._v(", divided into twenty "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sols")]), _vm._v(" (later "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sous")]), _vm._v("), which was worth twelve "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("dernier")]), _vm._v(". One "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("ecu ")]), _vm._v("was worth the equivalent of six "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("livres tournois")]), _vm._v(". The value of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("livre tournois")]), _vm._v(" to the pound fluctuated, however it is estimated that there were ten "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("livres tournois")]), _vm._v(" in the pound, with one shilling being worth two "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("livres tournois")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dates are given according to contemporary sources that followed the Julian calendar in use at the time. With the adoption of the Gregorian Calendar in 1752, account should be taken of the fact that these dates do not match with the exact dates of our current calendar. The difference between the two calendars in the fifteenth century is nine days, so the Battle of Bosworth, while fought on 22 August in 1485, would have actually been 13 August in our contemporary calendar. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730fafd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 81
// module chunks = 0